export const capitalizeFirstLetter = (text = ''): string | undefined => {
  if (typeof text !== 'string' || text === null || !text) {
    return text
  }

  return text.replace(/^[\p{L}\d_]/u, (c) => c.toUpperCase())
}
